import type {ErrorLogRef, Instant, UUID} from './common'
import type {EntityLink} from './entity-link'
/* eslint-disable i18next/no-literal-string */
export const ProvisioningAction = {
    GRANT: 'GRANT',
    REVOKE: 'REVOKE',
    CREATE_ACCOUNT: 'CREATE_ACCOUNT',
    DISABLE_ACCOUNT: 'DISABLE_ACCOUNT',
    ENABLE_ACCOUNT: 'ENABLE_ACCOUNT',
    DELETE_ACCOUNT: 'DELETE_ACCOUNT',
    UPDATE_ACCOUNT: 'UPDATE_ACCOUNT',
} as const;
export type ProvisioningAction = typeof ProvisioningAction[keyof typeof ProvisioningAction];

export const ProvisioningTaskStatus = {
    QUEUED: 'QUEUED',
    RUNNING: 'RUNNING',
    FAILED: 'FAILED',
    DONE: 'DONE',
    CANCELED: 'CANCELED',
} as const;
export type ProvisioningTaskStatus = typeof ProvisioningTaskStatus[keyof typeof ProvisioningTaskStatus];

export interface ProvisioningTask {
    id: UUID
    identity: EntityLink
    enforcementObject: EntityLink | null
    targetSystem: EntityLink
    accountId: UUID | null
    accountExternalIdentifier: string | null
    action: ProvisioningAction
    status: ProvisioningTaskStatus
    error: string | null
    retryCount: number
    maxRetries: number
    nextRetryAt: Instant | null
    createdAt: Instant
    updatedAt: Instant
    errorLogRef: ErrorLogRef | null
}

export interface ProvisioningTaskHistory {
    id: UUID
    identity: EntityLink
    enforcementObject: EntityLink | null
    targetSystem: EntityLink
    accountId: UUID | null
    action: ProvisioningAction
    status: ProvisioningTaskStatus
    error: string | null
    retryCount: number
    maxRetries: number
    createdAt: Instant
    completedAt: Instant
    errorLogRef: ErrorLogRef | null
}

export const BulkRetrySkipReason = {
    NOT_FOUND: 'NOT_FOUND',
    NOT_FAILED: 'NOT_FAILED',
} as const;
export type BulkRetrySkipReason = typeof BulkRetrySkipReason[keyof typeof BulkRetrySkipReason];

export interface SkippedTask {
    taskId: UUID
    reason: BulkRetrySkipReason
}

export interface BulkRetryRequest {
    taskIds: UUID[]
}

export interface BulkRetry {
    retried: number
    skipped: SkippedTask[]
}
